export default {
    MENOR_PRECO: {texto: 'Menor Preço', valor: 'MENOR_PRECO'},
    MAIOR_DESCONTO: {texto: 'Maior Desconto', valor: 'MAIOR_DESCONTO'},
}
